import Breadcrumb from "components/Common/Breadcrumb"
import { useEffect, useMemo, useState } from "react"
import { FaEdit, FaPlus, FaSave } from "react-icons/fa"
import { MdCancel, MdDelete } from "react-icons/md"
import {
    Button,
    Card,
    CardBody,
    Input,
    Modal,
    ModalBody,
    ModalFooter,
    ModalHeader,
    Table,
} from "reactstrap"
import React from "react"
import Loader from "components/Loader/Loader"
import { usePermissionData } from "AppContext"
import Swal from "sweetalert2"
import {
    fetchData,
    FetchDeleteData,
    FetchPostData,
    FetchPutData,
} from "utils/Common_api_functions"

const Equipement = () => {
    const [data, setData] = useState([])
    const [loading, setLoading] = useState(false)
    const [pageSize, setPageSize] = useState(20)

    const [searchString, setSearchString] = useState("")

    useEffect(() => {
        getEquipmentCategory()
    }, [])

    async function getEquipmentCategory() {
        const APIData = await fetchData(setLoading, "equipment/category")
        if (APIData?.success) {
            setData(APIData?.data)
        }
    }

    const filteredData = useMemo(() => {
        return data.filter(item =>
            item?.name?.toLowerCase().includes(searchString.toLowerCase())
        )
    }, [data, searchString])

    // Pagination
    const [currentPage, setCurrentPage] = useState(1)

    const totalPages = Math.ceil(filteredData.length / pageSize)
    const start = (currentPage - 1) * pageSize

    const paginatedData = useMemo(() => {
        const end = start + pageSize
        return filteredData.slice(start, end)
    }, [filteredData, currentPage, pageSize])

    const [modalOpen, setModalOpen] = useState(false)
    const [selectedCategory, setSelectedCategory] = useState({})

    const { checkAccess } = usePermissionData()

    const handleSubmit = async () => {
        if (selectedCategory?.id) {
            const APIdata = await FetchPutData(
                setLoading,
                "equipment/category",
                selectedCategory?.id,
                selectedCategory
            )
            if (APIdata?.data?.success) {
                Swal.fire({
                    title: "Equipement Updated Successfully.",
                    text: APIdata?.data?.message,
                    icon: "success",
                })
                setModalOpen(false)
                getEquipmentCategory()
                setSelectedCategory({})
            } else {
                Swal.fire({
                    title: "Error Updating Equipement.",
                    text: APIdata?.response?.data?.message,
                    icon: "error",
                })
            }
        } else {
            const APIdata = await FetchPostData(
                setLoading,
                "equipment/category",
                selectedCategory
            )
            if (APIdata?.data?.success) {
                Swal.fire({
                    title: "Equipement Added Successfully.",
                    text: APIdata?.data?.message,
                    icon: "success",
                })
                setModalOpen(false)
                setSelectedCategory({})
                getEquipmentCategory()
            } else {
                Swal.fire({
                    title: "Error Adding Equipement.",
                    text: APIdata?.response?.data?.message,
                    icon: "error",
                })
            }
        }
    }

    const handleDelete = (staff, id) => {
        Swal.fire({
            title: `Are you sure you want to delete ${staff?.name}?`,
            text: "This action cannot be undone!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "Cancel",
        }).then(async result => {
            if (result.isConfirmed) {
                const APIdata = await FetchDeleteData(
                    setLoading,
                    "equipment/category",
                    id
                )
                if (APIdata?.data?.success) {
                    Swal.fire({
                        title: "Equipment Deleted Successfully.",
                        text: APIdata?.data?.message,
                        icon: "success",
                    })
                    getEquipmentCategory()
                } else {
                    Swal.fire({
                        title: "Error Deleting Equipment.",
                        text: APIdata?.response?.data?.message,
                        icon: "error",
                    })
                }
            }
        })
    }

    return (
        <div className="page-content">
            {loading && <Loader />}
            <Breadcrumb title="Dashboard" breadcrumbItem="Equipement Category" />

            <Card className="shadow-lg">
                <CardBody>
                    {/* Top controls */}
                    <div className="d-flex justify-content-between align-items-center mb-3">
                        <div className="d-flex gap-3">
                            <Input
                                type="select"
                                value={pageSize}
                                onChange={e => {
                                    setPageSize(Number(e.target.value)), setCurrentPage(1)
                                }}
                                className="rounded-4 w-auto pe-5"
                            >
                                <option value={20}>20</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                            </Input>

                            <Input
                                className="rounded-4"
                                placeholder="Search Equipement"
                                value={searchString}
                                onChange={e => setSearchString(e.target.value)}
                            />
                        </div>
                        {checkAccess(2, "add") && (
                            <Button
                                className="btn-blue rounded-4 px-3"
                                onClick={() => {
                                    setSelectedCategory({}), setModalOpen(true)
                                }}
                            >
                                <FaPlus className="me-2" />
                                Equipement
                            </Button>
                        )}
                    </div>

                    {/* Table */}
                    <Table bordered responsive>
                        <thead className="table-dark">
                            <tr>
                                <th>#</th>
                                <th>Name</th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>

                        <tbody>
                            {paginatedData.length === 0 ? (
                                <tr>
                                    <td colSpan="9" className="text-center">
                                        No Equipment found
                                    </td>
                                </tr>
                            ) : (
                                paginatedData.map((item, index) => (
                                    <tr key={item.id}>
                                        <td>{start + index + 1}</td>

                                        <td className="d-flex align-items-center gap-3">
                                            {item.name}
                                        </td>

                                        <td className="text-center">
                                            {checkAccess(2, "edit") && (
                                                <Button
                                                    className="bg-success text-white me-2 border-0 shadow-none"
                                                    onClick={() => {

                                                        setSelectedCategory(item)
                                                        setModalOpen(true)
                                                    }}
                                                >
                                                    <FaEdit size={16} />
                                                </Button>
                                            )}

                                            {checkAccess(2, "delete") && (
                                                <Button
                                                    className="bg-danger text-white border-0 shadow-none"
                                                    onClick={() => handleDelete(item, item?.id)}
                                                >
                                                    <MdDelete size={18} />
                                                </Button>
                                            )}
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                    <nav
                        aria-label="Page navigation example"
                        className="d-flex justify-content-between mt-3"
                    >
                        <h5>
                            Showing {start + 1} to{" "}
                            {Math.min(start + pageSize, filteredData.length)} of {data.length}{" "}
                            entries
                        </h5>
                        <ul className="pagination mb-0">
                            <li
                                className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                            >
                                <button
                                    className="page-link"
                                    onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}
                                >
                                    Previous
                                </button>
                            </li>

                            {[...Array(totalPages)].map((_, i) => {
                                const pageNum = i + 1
                                return (
                                    <li
                                        key={pageNum}
                                        className={`page-item ${pageNum === currentPage ? "active" : ""
                                            }`}
                                    >
                                        <button
                                            className="page-link"
                                            onClick={() => setCurrentPage(pageNum)}
                                        >
                                            {pageNum}
                                        </button>
                                    </li>
                                )
                            })}

                            <li
                                className={`page-item ${currentPage === totalPages ? "disabled" : ""
                                    }`}
                            >
                                <button
                                    className="page-link"
                                    onClick={() =>
                                        setCurrentPage(prev => Math.min(prev + 1, totalPages))
                                    }
                                >
                                    Next
                                </button>
                            </li>
                        </ul>
                    </nav>
                </CardBody>
            </Card>

            <Modal isOpen={modalOpen}>
                <ModalHeader toggle={() => setModalOpen(false)}>
                    {selectedCategory?.id ? "Edit" : "Add"} Equipement Category
                </ModalHeader>
                <ModalBody>
                    <label>Equipement Category</label>
                    <input
                        className="form-control"
                        value={selectedCategory?.name}
                        onChange={e =>
                            setSelectedCategory(prev => ({ ...prev, name: e.target.value }))
                        }
                    ></input>
                </ModalBody>
                <ModalFooter>
                    <Button className="btn-blue" onClick={() => handleSubmit()}>
                        <FaSave /> Save
                    </Button>
                    <Button className="btn-danger" onClick={() => setModalOpen(false)}>
                        <MdCancel /> Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        </div>
    )
}

export default Equipement
